
import DashboardLayout from 'src/pages/Layout/DashboardLayout.vue';
import AuthLayout from 'src/pages/Auth/AuthLayout.vue';
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue';

// Dashboard pages
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Dashboard/Dashboard.vue');
import Widgets from 'src/pages/Widgets.vue';

//Lightpage pages
const LightPage = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/LightPage/LightPage.vue');
// import Widgets from 'src/pages/Widgets.vue';

//Cluster Schedule pages
const ClusterScheduler = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/ClusterScheduler/clusterscheduler.vue');

// Scheduler
const Weekend = () => 
  import('src/pages/ClusterScheduler/weekend2.vue');

// Scheduler holiday
const Setholidays = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Setholidays/setholidays.vue');

// Analytic
const DataAnalyticLight = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/DataAnalyticLight/DataAnalytic.vue');


// Cluster page
const DataAnalyticCluster = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/DataAnalyticCluster/DataAnalytic.vue');

const Cluster = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Cluster/Cluster.vue');

const listCluster = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Cluster/listCluster.vue');

// MLC
const mlc = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/MLC/mlc.vue');

// LUX
const lux = () =>
  import(/* webpackChunkName: "dashboard" */ 'src/pages/Lux/Lux.vue');

// list of feederpillar

const listFeederPillar = () =>
import('src/pages/FeederPillar/listFeederPillar.vue');

const operationOverview = () =>
import('src/pages/Operation/overview.vue');

const network = () =>
import('src/pages/Network/network.vue');

const ticketstatus = () =>
import('src/pages/Operation/ticketstatus.vue');

const performance = () =>
import('src/pages/Operation/performance.vue');

const report = () =>
import('src/pages/Operation/report.vue');

const analyticV2 = () =>
import('src/pages/AnalyticV2/analyticV2.vue');


//admin pages 
const ClusterManage = () => import('src/pages/Management/ClusterManagement.vue');
const UserManage = () => import('src/pages/Management/UserManagement.vue');
const DeviceManage = () => import('src/pages/Management/DeviceManagement.vue');
const GwManage = () => import('src/pages/Management/GatewayManagement.vue');
const FeederpillarManage = () => import('src/pages/Management/FeederpillarManagement.vue');

//eventpage
const NotifyManagement = () => import('src/pages/EventManagement/Notify.vue');
const TrailManagement = () => import('src/pages/EventManagement/Trail.vue');

// scheduler
// const Weekend = () => import('src/pages/ClusterScheduler/weekend.vue');

//admin route
let adminMenu = {
  path: '/admin',
  component: DashboardLayout,
  redirect: '/admin',
  children: [
    {
      path: 'clustermanagement',
      name: 'Cluster management',
      components: { default: ClusterManage }
    },
    {
      path: 'user',
      name: 'User management',
      components: { default: UserManage }
    },
    {
      path: 'device',
      name: 'Device management',
      components: { default: DeviceManage }
    },
    {
      path: 'gateway',
      name: 'Gateway management',
      components: { default: GwManage }
    },
    {
      path: 'feederpillar',
      name: 'Feeder Pillar management',
      components: { default: FeederpillarManage }
    },
  ]
};
let loginRoute = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
};

let eventMenu = {
  path: '/event',
  component: DashboardLayout,
  redirect: '/event',
  children: [
    {
      path: 'notifymanagement',
      name: 'Notifcation management',
      components: { default: NotifyManagement }
    },
    {
      path: 'trailmanagement',
      name: 'Trail Logs',
      components: { default: TrailManagement }
    }
  ]
};

let subTenantMenu = {
  path: '/tenant',
  component: DashboardLayout,
  redirect: '/tenant',
  children: [
    {
      path: 'notifymanagement',
      name: 'Notifcation management',
      components: { default: NotifyManagement }
    },
    {
      path: 'trailmanagement',
      name: 'Trail Logs',
      components: { default: TrailManagement }
    }
  ]
};

const routes = [
  {
    path: '/',
    redirect: '/login',
    name: 'Login',
  },
  loginRoute,
  eventMenu,

  adminMenu,
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    name: 'Dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        components: { default: Dashboard }
      },
      {
        path: '/light/:deviceid',
        name: 'Light Page',
        components: { default: LightPage }
      },
      {
        path: 'dataanalyticlight/:deviceid',
        name: 'Data Analytic',
        components: { default: DataAnalyticLight }
      },
      {
        path: 'dataanalyticcluster/:clusterid',
        name: 'Data Analytic Cluster',
        components: { default: DataAnalyticCluster },
        props: true
      },
      {
        path: '/cluster/:clusterid',
        name: 'Cluster',
        components: { default: Cluster }
      },
      {
        path: 'clusterscheduler',
        name: 'Cluster Scheduler',
        components: { default: ClusterScheduler}
      },
      {
        path: 'weekend',
        name: 'Weekend',
        components: { default: Weekend}
      },
      {
        path: 'setholidays',
        name: 'Set holidays',
        components: {default: Setholidays }
      },
      {
        path: 'listcluster',
        name: 'List of Cluster',
        components: {default: listCluster }
      },
      {
        path: '/listfeederpillar/:fpid',
        name: 'List of Feeder Pillar',
        components: {default: listFeederPillar }
      },
      {
        path: 'operation',
        name: 'Overview',
        components: {default: operationOverview }
      },
      {
        path: 'network',
        name: 'Network',
        components: {default: network }
      },
      {
        path: '/ticketstatus/:workorderid',
        name: 'Work Order Status',
        components: {default: ticketstatus }
      },
      {
        path: 'performance',
        name: 'Performance Report',
        components: {default: performance }
      },
      {
        path: 'report',
        name: 'Report',
        components: {default: report }
      },
      {
        path: 'analyticv2',
        name: 'DATA ANALYTICS',
        components: {default: analyticV2 }
      },
      {
        path: 'mlc',
        name: 'MASTER LIGHT CONTROLLER',
        components: {default: mlc }
      },
      {
        path: 'lux/:deviceid/:devicetoken',
        name: 'LUX SENSOR',
        components: {default: lux }
      },  
    ]
  },
  { path: '*', component: NotFound }
];

export default routes;
